import { Button } from 'antd';

import { amplitudeTrack } from 'app/utils/track/amplitude';

import type { ExtranetPaymentDisplayProps } from '../../utils';

type BankTransferActionButtonProps = {
  displayProps: ExtranetPaymentDisplayProps;
  apiUrl?: string;
  hotelId?: number | null;
  token?: string;
};

const getButtonText = (buttonProps: ExtranetPaymentDisplayProps) => {
  if (buttonProps.stripeAccountError) {
    return 'Update my Stripe KYC';
  } else if (buttonProps.newHotel) {
    return 'Configure my Stripe account';
  }

  return 'Access my Stripe account';
};

export const BankTransferActionButton = ({
  displayProps,
  apiUrl,
  hotelId,
  token,
}: BankTransferActionButtonProps) => {
  if (
    !apiUrl ||
    !hotelId ||
    !token ||
    displayProps.adyenPayout ||
    !displayProps.stripeAllowed ||
    (!displayProps.stripeAccountConfigured && displayProps.VCCActive)
  ) {
    return <></>;
  }

  return (
    <Button
      type={
        displayProps.stripeAccountConfigured && !displayProps.stripeAccountError
          ? undefined
          : 'primary'
      }
      disabled={!displayProps.hotelUser}
      onClick={() => {
        window.open(
          `${apiUrl}/hotels/${hotelId}/stripe-session?token=${token}`
        );
        amplitudeTrack('Click Access Stripe account');
      }}
    >
      {getButtonText(displayProps)}
    </Button>
  );
};
